import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import TabelaAuditoriaSistema from "./TabelaAuditoriaSistema";
import TabelaModificacoesSistema from "./TabelaModificacoesSistema";

export default function Index() {
  const [openTable, setOpenTable] = useState<"auditoria" | "modificacoes" | null>(null);
  const navigate = useNavigate();
  const location = useLocation();

  const handleToggle = (table: "auditoria" | "modificacoes") => {
    setOpenTable((prev) => (prev === table ? null : table));

    navigate(location.pathname, { replace: true });
  };

  return (
    <div>
      <TabelaAuditoriaSistema
        isOpen={openTable === "auditoria"}
        onToggle={() => handleToggle("auditoria")}
      />
      <TabelaModificacoesSistema
        isOpen={openTable === "modificacoes"}
        onToggle={() => handleToggle("modificacoes")}
      />
    </div>
  );
}
